<template>
  <teleport to="body">
    <div v-if="modelValue && config" class="wg-overlay" @click.self="close">
      <div class="wg-dialog" role="dialog" :aria-labelledby="titleId">
        <header class="wg-dialog-header">
          <h2 :id="titleId">{{ config.dialogTitle || '工作指引' }}</h2>
          <button type="button" class="wg-close" aria-label="关闭" @click="close">&times;</button>
        </header>
        <div class="wg-dialog-body">
          <section
            v-for="(sec, idx) in sortedSections"
            :key="sec.id || idx"
            class="wg-section"
          >
            <h3 class="wg-section-title">{{ sec.title }}</h3>
            <template v-if="sec.type === 'link' && sec.url">
              <a
                :href="sec.url"
                class="wg-link"
                target="_blank"
                rel="noopener noreferrer"
              >{{ sec.urlLabel || sec.url }}</a>
              <p v-if="sec.body" class="wg-section-body">{{ sec.body }}</p>
            </template>
            <ul v-else-if="sec.type === 'list' && sec.items?.length" class="wg-list">
              <li v-for="(item, i) in sec.items" :key="i">{{ item }}</li>
            </ul>
            <p v-else-if="sec.body" class="wg-section-body">{{ sec.body }}</p>
          </section>
          <div
            v-if="config.footerHighlight?.enabled && config.footerHighlight?.text"
            class="wg-footer-highlight"
          >
            <a
              v-if="config.footerHighlight.url"
              :href="config.footerHighlight.url"
              target="_blank"
              rel="noopener noreferrer"
            >{{ config.footerHighlight.text }}</a>
            <span v-else>{{ config.footerHighlight.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'WorkGuidanceDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    config: { type: Object, default: null }
  },
  emits: ['update:modelValue'],
  computed: {
    titleId() {
      return 'work-guidance-title'
    },
    sortedSections() {
      const list = this.config?.sections || []
      return [...list].sort((a, b) => (a.order || 0) - (b.order || 0))
    }
  },
  methods: {
    close() {
      this.$emit('update:modelValue', false)
    }
  }
}
</script>

<style scoped>
.wg-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.wg-dialog {
  width: min(720px, 100%);
  max-height: 85vh;
  background: linear-gradient(160deg, rgba(42, 82, 152, 0.97) 0%, rgba(30, 60, 114, 0.97) 100%);
  border-radius: 12px;
  color: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.wg-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.wg-dialog-header h2 {
  margin: 0;
  font-size: 20px;
  letter-spacing: 2px;
}
.wg-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.85;
}
.wg-dialog-body {
  padding: 16px 22px 20px;
  overflow-y: auto;
  flex: 1;
}
.wg-section {
  margin-bottom: 16px;
}
.wg-section-title {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 700;
}
.wg-section-body {
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.7;
  opacity: 0.95;
  white-space: pre-wrap;
}
.wg-link {
  color: #a8d4ff;
  word-break: break-all;
  text-decoration: underline;
}
.wg-list {
  margin: 6px 0 0;
  padding-left: 1.2em;
  font-size: 14px;
  line-height: 1.6;
}
.wg-footer-highlight {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed rgba(255, 255, 255, 0.25);
  text-align: center;
}
.wg-footer-highlight a {
  color: #ffb4b4;
  font-weight: 700;
  text-decoration: underline;
}
</style>
